













import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {確定送信者型} from '@/type/user/sender';

@Component({})
export default class SenderSelector extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;
  @Prop({default: true})
  private disabled!: boolean;
  @Prop({default: false})
  private ハンディを含む!: boolean;

  private 確定送信者一覧: 確定送信者型[] = [];

  public mounted(): void {
    this.initialize();
  }

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  private async initialize(): Promise<void> {
    if (this.ハンディを含む) {
      this.確定送信者一覧 = await api.ハンディを含む確定送信者一覧を取得する();
      return;
    }
    this.確定送信者一覧 = await api.確定送信者一覧を取得する();
  }
}
